import { Title, Flex, Tabs, ScrollArea } from '@mantine/core';
import {
  IconLink,
  IconMail,
  IconMessageCircle,
  IconBrandTelegram,
  IconLibraryPhoto,
  IconCurrencyDollar,
} from '@tabler/icons-react';

import {
  BaseUrl,
  Email,
  Sms,
  Telegram,
  Images,
  Currencies,
} from '@/modules/config';

export const Config = () => {
  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Настройки</Title>
      </Flex>

      <Tabs defaultValue="baseUrl" keepMounted={false}>
        <ScrollArea scrollbarSize={2} scrollbars="x">
          <Tabs.List mb={20} style={{ flexWrap: 'nowrap' }}>
            <Tabs.Tab value="baseUrl" leftSection={<IconLink size={12} />}>
              Base URL
            </Tabs.Tab>
            <Tabs.Tab value="email" leftSection={<IconMail size={12} />}>
              Email
            </Tabs.Tab>
            <Tabs.Tab value="sms" leftSection={<IconMessageCircle size={12} />}>
              Sms
            </Tabs.Tab>
            <Tabs.Tab value="telegram" leftSection={<IconBrandTelegram size={12} />}>
              Telegram bot
            </Tabs.Tab>
            <Tabs.Tab value="images" leftSection={<IconLibraryPhoto size={12} />}>
              Картинки
            </Tabs.Tab>
            <Tabs.Tab value="currencies" leftSection={<IconCurrencyDollar size={12} />}>
              Валюты
            </Tabs.Tab>
          </Tabs.List>
        </ScrollArea>

        <Tabs.Panel value="baseUrl">
          <BaseUrl />
        </Tabs.Panel>
        <Tabs.Panel value="email">
          <Email />
        </Tabs.Panel>
        <Tabs.Panel value="sms">
          <Sms />
        </Tabs.Panel>
        <Tabs.Panel value="telegram">
          <Telegram />
        </Tabs.Panel>
        <Tabs.Panel value="images">
          <Images />
        </Tabs.Panel>
        <Tabs.Panel value="currencies">
          <Currencies />
        </Tabs.Panel>
      </Tabs>
    </>

  );
};
